<template>
  <div :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
    <!--   <a class="simple-text logo-mini"
         href="https://inmobito.app">
          <div class="logo-img"> -->
            <div class="text-center logo-normal">
              <a class="show-hide-menu" @click.prevent="minimizeSidebar(1)">
                <i :class="$sidebar.isMinimized ? 'ti-menu' : 'ti-menu'"></i>
              </a>

            </div>
            <div class="logo-mini">
              <!-- <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
                <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
              </button> -->
            </div>
          <!-- </div>
      </a> -->
    <!--   <a class="simple-text logo-normal"
         href="https://inmobito.app">
          {{ title }}
      </a> -->
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :loc="link.name == 'orderspos' ? default_location_for_admin_order : null "
                        :key="link.name + index"
                        :link="link"
                        :ref="link.session !== undefined ? link.session : ''">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

        <li
          v-if="userRole != 'USER_CUSTOM' || (userRole === 'USER_CUSTOM' && this.userHasRight('general_can_access_suport'))"
          ref="supportTicketItem"
          class="support-ticket-item">
          <a
            href="#"
            class="buton-suport-custom"
            @click.prevent="onSupportTicketClick">
            <i class="icon-menu icon-menu-chat"></i>
            <p>{{ $t('pages.supportTicket') }}</p>
          </a>
        </li>

        <li class="logout-link">
          <a _href="/logout" v-on:click.prevent="logout" class=""><i class="icon-menu icon-menu-logout"></i> <p>{{ $t('general.logout')}}</p></a>
          <div class="logo-footer">
            <a href="/"><img :src="logo" alt="TapTasty"></a>
          </div>
        </li>

      </ul>
    </div>

    <div
      v-if="showSupportLocationModal"
      class="modal-overlay support-location-modal-overlay"
      @click.self="closeSupportLocationModal">
      <div class="modal-dialog support-location-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t('dashboard.selectLocation') }}</h4>
            <button type="button" class="close" @click="closeSupportLocationModal">
              <i class="ti-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>{{ $t('orders.location') }}</label>
              <el-select
                v-model="selectedSupportLocationToken"
                class="support-location-select"
                filterable
                clearable
                popper-class="support-location-select-dropdown"
                style="width: 100%"
                :placeholder="$t('general.select')">
                <el-option
                  v-for="loc in supportLocations"
                  :key="loc.token"
                  :label="loc.name"
                  :value="loc.token"
                />
              </el-select>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a
                href="#"
                class="btn btn-danger btn-icon mar-rt-10 delete"
                @click.prevent="closeSupportLocationModal"
              >
                <img src="/static/img/icons/icon-close.png">
                {{ $t('general.cancel') }}
              </a>
              <button
                type="button"
                class="btn btn-icon btn-success mar-rt-10 save"
                :disabled="!selectedSupportLocationToken || supportWidgetLoading"
                @click="confirmSupportLocation"
              >
                <img src="/static/img/icons/save.png">
                {{ $t('general.confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="orderFiscalError" class="alert-box-wrap-fiscal">
      <div class="alert-box-fiscal" >
        <span class="number">Nu s-a putut printa bonul pentru comanda: {{ orderFiscalError }}</span>
      </div>
    </div>
    <div class="alert-box-wrap" v-if="this.$route.name !== 'Dispatch'">

      <template v-for="(call, callIndex) in all_waiter_calls">
        <div class="alert-box waiter" @click="markWaiterCallView(callIndex, call.id)">
          <span class="name">{{ call.zone }} {{ call.type }} {{ call.number }} </span>
          <span class="reason" v-if="call.reason"><b>{{call.reason}}</b></span>
        </div>
      </template>

      <div class="alert-box" v-if="newOrdersCount > 0" @click="goToOrders('NEW')">
        <i class=""></i>
        <span class="number">{{ newOrdersCount }} {{ $t('ordersStatus.NEW')}}</span>
      </div>
      <div class="alert-box processing" v-if="processingOrdersCount > 0" @click="goToOrders('PROCESSING')">
        <i class=""></i>
        <span class="number">{{ processingOrdersCount }} {{ $t('ordersStatus.PROCESSING')}}</span>
      </div>
      <div class="alert-box checkIn" v-if="ordersCheckIn > 0" @click="goToOrders('ordersCheckIn')">
        <i class=""></i>
        <span class="number">{{ ordersCheckIn }} {{ $t('ordersStatus.checkIn')}}</span>
      </div>
    </div>
    <!-- <audio src="/static/audio/alarm.mp3" muted ></audio> -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import PerfectScroll from 'perfect-scrollbar'
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  import { Select, Option } from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import axios from 'axios'
  Vue.use(Select)
  Vue.use(Option)
  export default {
    props: {
      title: {
        type: String,
        default: 'tapTasty'
      },
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/logo-taptasty.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    created () {
      if (localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')]) {
        window.cache_date = new Date(localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')])
      }
      if (this.$session.get('selectedCompanyData').default_location_for_admin_order) {
        this.default_location_for_admin_order = this.$session.get('selectedCompanyData').default_location_for_admin_order
      }
      this.$bus.$off('fiscalEvent')
      this.$bus.$on('fiscalEvent', this.printFiscal)
      this.$bus.$off('fiscalPosPayment')
      this.$bus.$on('fiscalPosPayment', this.fiscalPosPayment)
      this.$bus.$off('getRaport')
      this.$bus.$on('getRaport', this.getRaport)
      this.minimizeSidebar()
      this.$nextTick(() => {
        this.startPlaySound()
      })
      this.userRole = this.$session.get('userDataRole')
      this.$bus.$on('stopSound', this.handleStopSound)
      this.getCounter()
      setInterval(() => {
        if (!this.timeoutCounters) { // fail-safe
          this.getCounter()
        }
      }, 1000 * 60)
    },
    data () {
      return {
        all_waiter_calls: [],
        printFiscalDisabled: false,
        fiscalPosPaymentDisabled: false,
        default_location_for_admin_order: null,
        children: [],
        timeoutCounters: null,
        collapsed: true,
        heartbeatSet: false,
        newOrdersCount: 0,
        processingOrdersCount: 0,
        ordersCheckIn: 0,
        ordersWithSound: 0,
        oldOrdersCheckIn: 0,
        audioFile: null,
        audioPlayed: true,
        userRole: null,
        hideOwnerOnlyLinks: false,
        orderFiscalError: false,
        showSupportLocationModal: false,
        selectedSupportLocationToken: '',
        supportLocations: [],
        supportWidgetLocationToken: '',
        supportScriptHost: null,
        supportLinkObserver: null,
        supportWidgetLoading: false
      }
    },
    computed: {
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      toggleAlertMenu (ref, shouldAlert) {
        const component = Array.isArray(ref) ? ref[0] : ref
        const el = component && component.$el
        if (!el || !el.classList) {
          return
        }
        if (shouldAlert) {
          el.classList.add('alert-menu')
        } else {
          el.classList.remove('alert-menu')
        }
      },
      getSupportLocations () {
        const company = this.$session.get('selectedCompanyData') || {}
        return (company.locations_details || []).filter(location => location && location.token)
      },
      getSupportUserId () {
        try {
          return JSON.parse(this.$session.get('userData')).id || null
        } catch (e) {
          return null
        }
      },
      onSupportTicketClick () {
        const locations = this.getSupportLocations()
        if (!locations.length || !this.$session.get('selectedCompany')) {
          return
        }
        if (locations.length === 1) {
          const locationToken = locations[0].token
          this.openSupportLocationSelect(locationToken)
          this.$nextTick(() => {
            this.loadAndOpenSupportWidget(locationToken)
          })
          return
        }
        this.openSupportLocationSelect()
      },
      openSupportLocationSelect (preselectToken) {
        const locations = this.getSupportLocations()
        if (!locations.length) {
          return
        }
        this.supportLocations = locations
        this.selectedSupportLocationToken = preselectToken ||
          this.supportWidgetLocationToken ||
          (locations.length === 1 ? locations[0].token : '')
        this.showSupportLocationModal = true
      },
      closeSupportLocationModal () {
        this.showSupportLocationModal = false
      },
      confirmSupportLocation () {
        if (!this.selectedSupportLocationToken || this.supportWidgetLoading) {
          return
        }
        const locationToken = this.selectedSupportLocationToken
        this.closeSupportLocationModal()
        this.loadAndOpenSupportWidget(locationToken)
      },
      handleSupportWidgetError (errorMessage, locationToken) {
        const knownError = 'Support widget token is not available for this location'
        const message = errorMessage === knownError
          ? this.$t('pages.supportWidgetTokenUnavailable')
          : (errorMessage || this.$t('validations.wentWrong'))

        swal('', message, 'error').then(() => {
          this.openSupportLocationSelect(locationToken)
        })
      },
      cleanupSupportWidget () {
        if (this.supportLinkObserver) {
          this.supportLinkObserver.disconnect()
          this.supportLinkObserver = null
        }
        document.querySelectorAll('[data-taptasty-support-widget="true"]').forEach(node => node.remove())
        if (this.supportScriptHost && this.supportScriptHost.parentNode) {
          this.supportScriptHost.parentNode.removeChild(this.supportScriptHost)
        }
        this.supportScriptHost = null
        this.supportWidgetLocationToken = ''
      },
      async loadAndOpenSupportWidget (locationToken) {
        const companyId = this.$session.get('selectedCompany')
        if (!companyId || !locationToken || this.supportWidgetLoading) {
          return
        }

        if (
          this.supportWidgetLocationToken === locationToken &&
          this.supportScriptHost
        ) {
          const existingLink = this.supportScriptHost.querySelector('a[data-taptasty-support-link="true"]')
          const widgetHost = document.querySelector('[data-taptasty-support-widget="true"]')
          if (existingLink && widgetHost) {
            this.closeSupportLocationModal()
            // Defer so the current click finishes first; otherwise the widget's
            // document click handler closes the panel immediately after open.
            setTimeout(() => {
              existingLink.click()
            }, 0)
            return
          }
        }

        this.supportWidgetLoading = true
        this.cleanupSupportWidget()

        try {
          const bootstrapUrl = 'https://superadmin.taptasty.com/api/public/support/widget/bootstrap' +
            '?company_id=' + encodeURIComponent(companyId) +
            '&location_id=' + encodeURIComponent(locationToken)
          const response = await fetch(bootstrapUrl, {
            method: 'GET',
            credentials: 'omit',
            headers: { Accept: 'application/json' }
          })
          const payload = await response.json().catch(() => null)
          if (!response.ok || !payload || payload.success !== true || !payload.data) {
            const errorMessage = payload && typeof payload.error === 'string'
              ? payload.error
              : this.$t('validations.wentWrong')
            this.handleSupportWidgetError(errorMessage, locationToken)
            return
          }
        } catch (e) {
          this.handleSupportWidgetError(this.$t('validations.wentWrong'), locationToken)
          return
        } finally {
          this.supportWidgetLoading = false
        }

        this.closeSupportLocationModal()

        window.TapTastySupportPayload = () => ({
          userid: this.getSupportUserId(),
          posid: null
        })

        const host = document.createElement('div')
        host.style.display = 'none'
        host.setAttribute('data-taptasty-support-script-host', '1')
        document.body.appendChild(host)
        this.supportScriptHost = host
        this.supportWidgetLocationToken = locationToken

        this.supportLinkObserver = new MutationObserver(() => {
          const link = host.querySelector('a[data-taptasty-support-link="true"]')
          if (link) {
            this.supportLinkObserver.disconnect()
            this.supportLinkObserver = null
            link.click()
          }
        })
        this.supportLinkObserver.observe(host, { childList: true })

        const script = document.createElement('script')
        script.src = 'https://superadmin.taptasty.com/management/support-widget.js?t=' + Date.now()
        script.async = true
        script.dataset.taptastySupportWidgetScript = '1'
        script.dataset.companyId = String(companyId)
        script.dataset.locationId = String(locationToken)
        script.dataset.mode = 'inline'
        script.dataset.class = 'buton-suport-custom'
        script.dataset.label = this.$t('pages.supportTicket')
        script.dataset.payloadSource = 'TapTastySupportPayload'
        host.appendChild(script)
      },
      markWaiterCallView (index, id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          call_id: id
        }
        this.apiRequest('/mark-call-resolved', 'GET', data, (response) => {
          if (response.status === true) {
            this.all_waiter_calls.splice(index, 1)
          }
        })
      },
      showRedNotice (show) {
        if (show) {
          this.$bus.$emit('RedNotice', 1)
        } else {
          this.$bus.$emit('RedNotice', 0)
        }
      },
      async printFiscal (data) {
        if (!this.printFiscalDisabled) {
          this.printFiscalDisabled = true
          if (data.pay_method === 2 && data.with_pos) {
            let totalToSend = data.total
            totalToSend = totalToSend.toFixed(2)
            totalToSend = totalToSend.replace(',', '')
            totalToSend = parseInt(totalToSend.replace('.', ''))

            let printToIp = await this.getPrinterIp()
            this.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"POS^' + totalToSend + '"' + '\n]', (response) => {
              data.capture_transaction_response = response.data
              // this.apiRequest('/noauth/print-fiscal-net-answer/' + data.orderid, 'POST', data, function () {})
              if (response.data && response.data.ReceiptStatus) {
                this.printFiscalNet(data.orderid, data)
              } else {
                this.fiscalPrintError(data.orderid)
              }
            })
          } else {
            if (data.pay_method === 8) { // card_no_pos
              data.pay_method = 2 // card
            }
            this.printFiscalNet(data.orderid, data)
          }
        }
      },
      async fiscalPosPayment (data) {
        if (!this.fiscalPosPaymentDisabled) {
          this.fiscalPosPaymentDisabled = true
          let totalToSend = data.total
          totalToSend = totalToSend.toFixed(2)
          totalToSend = totalToSend.replace(',', '')
          totalToSend = parseInt(totalToSend.replace('.', ''))

          let printToIp = await this.getPrinterIp()
          this.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"POS^' + totalToSend + '"' + '\n]', (response) => {
            data.capture_transaction_response = response.data
            // this.apiRequest('/noauth/print-fiscal-net-answer/' + data.orderid, 'POST', data, function () {})
            if (response.data && response.data.ReceiptStatus) {
              this.fiscalPosPaymentDisabled = false
              this.$bus.$emit('completePaymentPos', data)
            } else {
              this.fiscalPosPaymentError(data.orderid)
            }
          })
        }
      },
      async getRaport (raportType) {
        let printToIp = await this.getPrinterIp()
        if (raportType === 'X') {
          this.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"X^",' + '\n]', (response) => {
          })
        }
        if (raportType === 'Z') {
          this.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"Z^",' + '\n]', (response) => {
          })
        }
      },
      printFiscalNet (orderid, data) {
        // var self = this
        this.apiRequest('/noauth/print-fiscal-net/' + orderid + '/0', 'GET', data, async (printerText) => {
          if (printerText.status) {
            let printToIp = await this.getPrinterIp()
            this.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + printerText.data + '\n]', (response) => {
              data.receipt_number = response.data
              data.receipt = printerText.data
              this.apiRequest('/noauth/print-fiscal-net-answer/' + orderid, 'POST', data, (answer) => {
                if (response.data && response.data.ErrorCode === '') {
                  if (this.$route.query.print_fiscal) {
                    this.$router.push('/add-order')
                  }
                  this.printFiscalDisabled = false
                  this.$bus.$emit('orders_pos_complete_order', data)
                }
              })
              if (response.data && response.data.ErrorCode === '') {
                this.orderFiscalError = ''
              } else {
                this.fiscalPrintError(data.orderid)
              }
            })
            // axios.post('http://localhost:65400/api/Receipt', '[\n' + printerText.data + '\n]')
            // .then(
            //   (response) => {
            //     if (response.data && response.data.ErrorCode === '') {
            //       data.receipt_number = response.data
            //       self.apiRequest('/noauth/print-fiscal-net-answer/' + orderid, 'POST', data, function (answer) {
            //         if (self.$route.query.print_fiscal) {
            //           self.$router.push('/add-order')
            //         } else {
            //           self.getData()
            //         }
            //       })
            //       this.orderFiscalError = ''
            //     } else {
            //       this.fiscalPrintError(data.orderid)
            //     }
            //   }
            // )
          } else {
            this.fiscalPrintError(data.orderid)
          }
        })
      },
      async getPrinterIp () {
        let printToIp = null
        if (JSON.parse(this.$session.get('userData')).fiscal_printer_id) {
          if (JSON.parse(this.$session.get('userData')).fiscal_printer) {
            // printToIp = 'http://' + JSON.parse(this.$session.get('userData')).fiscal_printer.ip_port_printer
            printToIp = JSON.parse(this.$session.get('userData')).fiscal_printer.ip_port_printer
          } else {
            let d1 = {
              'token': this.$session.get('token'),
              'company_id': this.$session.get('selectedCompany')
            }
            const fpResp = await new Promise((resolve, reject) => {
              this.apiRequest('/fiscal-printer/' + JSON.parse(this.$session.get('userData')).fiscal_printer_id, 'GET', d1, (response) => {
                if (response) {
                  resolve(response.data)
                } else {
                  reject(new Error('Eroare la obținerea datelor'))
                }
              })
            })
            if (fpResp) {
              // printToIp = 'http://' + fpResp.fiscalPrinter.ip_port_printer
              printToIp = fpResp.fiscalPrinter.ip_port_printer
            }
          }
        }
        return printToIp
      },
      initScrollBar () {
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar (isMinimizeFromButton) {
        if (isMinimizeFromButton) {
          this.$sidebar.toggleMinimize()
          this.$session.set('isMinimized', this.$sidebar.isMinimized)
        } else {
          let minMenu = this.$session.get('isMinimized')
          if (minMenu === undefined && this.$sidebar.isMinimized) {
            this.$sidebar.toggleMinimize()
          }
          if (minMenu === false && this.$sidebar.isMinimized) {
            this.$sidebar.toggleMinimize()
          } else if (minMenu && !this.$sidebar.isMinimized) {
            this.$sidebar.toggleMinimize()
          }
        }
      },
      heartbeat: function () {
        var self = this

        // setInterval(() => {
        //   // refresh value set in OrderView.Vue when a status is updated
        //   if (this.$session.get('refreshOrdersCount') === 'refresh') {
        //     this.$session.set('refreshOrdersCount', '')
        //     // self.getCounter()
        //   }
        // }, 1000 * 2)

        // setInterval(() => {
        //   // self.getCounter()
        // }, 1000 * 15)

        this.loadSound()
        let allowSoundAtNew = this.$session.get('selectedCompanyData')['is_allowed_sound_at_new']
        let allowSoundAtProcessing = this.$session.get('selectedCompanyData')['is_allowed_sound_at_processing']
        if ((((self.newOrdersCount > 0 && allowSoundAtNew && self.ordersWithSound > 0) || (self.processingOrdersCount > 0 && allowSoundAtProcessing && self.ordersWithSound > 0)) || self.all_waiter_calls.length) && this.$session.exists()) {
          self.playSound()
        }

        setInterval(() => {
          this.loadSound()
          if ((((self.newOrdersCount > 0 && allowSoundAtNew && self.ordersWithSound > 0) || (self.processingOrdersCount > 0 && allowSoundAtProcessing && self.ordersWithSound > 0)) || self.all_waiter_calls.length) && this.$session.exists()) {
            self.playSound()
          }
        }, 1000 * 3)
      },
      openPopup () {
        swal({
          text: this.$t('general.agreePopupMessage'),
          type: 'info',
          confirmButtonText: this.$t('general.agree'),
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
        .then((result) => {
          // this.loadSound()
          this.playQuietSound()
        })
      },
      loadSound () {
        // console.warn('audio load')
        // let sound = document.querySelector('audio')
        // if (sound) {
        //   sound.volume = 0
        // }
        // sound.play()
      },
      playSound () {
        // console.warn('audio play')
        // let sound = document.querySelector('audio')
        // if (sound) {
        //   sound.volume = 1
        //   sound.play()
        // }
        if (window.soundEffect) {
          window.soundEffect.src = '/static/audio/alarm.mp3'
          window.soundEffect.play()
        }
      },
      playQuietSound () {
        // console.warn('audio play')
        // let sound = document.querySelector('audio')
        // if (sound) {
        //   sound.volume = 1
        //   sound.play()
        // }
        if (window.soundEffect) {
          window.soundEffect.src = '/static/audio/quiet.mp3'
          window.soundEffect.play()
        }
      },
      startPlaySound () {
        // let sound = document.querySelector('audio')
        // sound.volume = 1

        // sound.play()
      },
      getCounter () {
        var data = {
          user_id: JSON.parse(this.$session.get('userData')).id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          status: 'NEW',
          seen: 0
        }
        var filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          data.location_ids = filterCookie.join(',')
        }
        // if no location is in the filter, send the allowed locations for non-admin users
        if ((data.location_ids === undefined || data.location_ids === '') && this.$session.get('userDataRole') === 'USER') {
          let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
          if (allowedLocations) {
            data.location_ids = allowedLocations.join(',')
          }
        }
        var self = this
        this.apiRequest('/counters', 'GET', data, function (response) {
          var newFeedback = false
          var newOrders = false
          var processingOrders = false
          var newNews = false
          if (response.status === true) {
            // all_waiter_calls
            if (response.data['all_waiter_calls'].length) {
              self.all_waiter_calls = response.data['all_waiter_calls']
            }

            if (response.data.last_menu_modification_for_cache) {
              self.createCacheForMenu(response.data.last_menu_modification_for_cache)
            }

            // red flag
            if (response.data['red_notice'] === 0) {
              self.showRedNotice(0)
            }
            if (response.data['red_notice'] === 1) {
              self.showRedNotice(1)
            }
            if (response.data['red_notice'] === 2 || response.data['force_logout']) {
              self.forceLogout()
              window.location.reload(true)
            }
            // new orders
            if (response.data['orders'] > 0) {
              newOrders = true
              self.newOrdersCount = response.data['orders']
            } else {
              self.newOrdersCount = 0
            }
            self.$session.set('newOrders', newOrders)
            self.$session.set('newOrdersCount', self.newOrdersCount)
            // provessing orders
            if (response.data['orders_processing'] > 0) {
              processingOrders = true
              self.processingOrdersCount = response.data['orders_processing']
            } else {
              self.processingOrdersCount = 0
            }
            self.$session.set('processingOrders', processingOrders)
            self.$session.set('processingOrdersCount', self.processingOrdersCount)
            // feedback
            if (response.data['feedbacks'] > 0) {
              newFeedback = true
            }
            self.$session.set('newFeedback', true)
            // news in newsletter
            if (response.data['newsletter_news'] > 0) {
              newNews = true
            }
            self.$session.set('newNews', true)

            // check_in
            if (response.data['orders_check_in'] > 0) {
              // processingOrders = true
              self.ordersCheckIn = response.data['orders_check_in']
            } else {
              self.ordersCheckIn = 0
            }
            if (response.data['orders_methods_sound'] > 0) {
              // processingOrders = true
              self.ordersWithSound = response.data['orders_methods_sound']
            } else {
              self.ordersWithSound = 0
            }
            if (self.oldOrdersCheckIn !== self.ordersCheckIn) {
              self.$session.set('temp-status', 'refreshSaveStatuses')
            }
            self.oldOrdersCheckIn = self.ordersCheckIn
          }
          self.toggleAlertMenu(self.$refs.newFeedback, newFeedback)
          self.toggleAlertMenu(self.$refs.newOrders, newOrders || processingOrders)
          self.toggleAlertMenu(self.$refs.newNews, newNews)

          clearTimeout(self.timeoutCounters)
          if (self.$session.get('refreshOrdersCount') === 'refresh') {
            self.$session.set('refreshOrdersCount', '')
            self.timeoutCounters = setTimeout(() => {
              self.getCounter()
            }, 1000 * 2)
          } else {
            self.timeoutCounters = setTimeout(() => {
              self.getCounter()
            }, 1000 * 60)
          }
        })
      },
      createCacheForMenu (refreshProductsDate) {
        const givenDate = new Date(refreshProductsDate + ' GMT')
        if (window.cache_date <= givenDate) {
          console.log('ClearCache')
          window.appInstanceCache = {}

          let databaseName = 'tapTasty_' + this.$session.get('selectedCompany')

          let deleteRequest = indexedDB.deleteDatabase(databaseName)
          deleteRequest.onsuccess = function (event) {
            console.log('Database deleted successfully')
          }
          deleteRequest.onerror = function (event) {
            console.error('Error deleting database:', event.target.error)
          }
          deleteRequest.onblocked = function (event) {
            console.warn('Database deletion blocked:', event.target.error)
          }

          window.cache_date = new Date()
          localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')] = window.cache_date.toISOString()
        }
      },
      goToOrders (status) {
        this.$session.set('temp-status', status)
        this.$nextTick(function () {
          // console.warn(this.$router)
          this.$router.replace('/orders')
        })
      },
      handleStopSound () {
        this.newOrdersCount = 0
        this.processingOrdersCount = 0
        this.ordersCheckIn = 0
      },
      fiscalPosPaymentError (orderId) {
        this.$bus.$emit('completePaymentPos', 0)
        this.fiscalPosPaymentDisabled = false
        this.orderFiscalError = orderId
        setInterval(() => {
          this.orderFiscalError = false
        }, 1000 * 3)
      },
      fiscalPrintError (orderId) {
        this.$bus.$emit('orders_pos_complete_order', 0)
        this.printFiscalDisabled = false
        this.orderFiscalError = orderId
        setInterval(() => {
          this.orderFiscalError = false
        }, 1000 * 3)
      }
    },
    mounted () {
      // window.addEventListener('load', () => {
      window.soundEffect = new Audio()
      let allowSoundAtNew = true
      let allowSoundAtProcessing = true
      if (this.$session.get('selectedCompanyData')) {
        allowSoundAtNew = this.$session.get('selectedCompanyData')['is_allowed_sound_at_new']
        allowSoundAtProcessing = this.$session.get('selectedCompanyData')['is_allowed_sound_at_processing']
      }
      if (this.$session.exists() && (allowSoundAtNew || allowSoundAtProcessing)) {
        this.openPopup(true)
      }
      // })

      if (!this.heartbeatSet) {
        // this.getCounter()
        this.heartbeat()
        this.heartbeatSet = true
        // this.audioFile = new Audio('/static/audio/alarm.mp3')
      }

      this.initScrollBar()
      this.toggleAlertMenu(this.$refs.newFeedback, this.$session.get('newFeedback'))
      this.toggleAlertMenu(this.$refs.newOrders, this.$session.get('newOrders'))
      this.toggleAlertMenu(this.$refs.newNews, this.$session.get('newNews'))
    },
    beforeDestroy () {
      PerfectScroll.destroy(this.$refs.sidebarScrollArea)
      clearTimeout(this.timeoutCounters)
      this.cleanupSupportWidget()
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  .sidebar .logout-link .logo-footer {
    width: 140px;
    height: 36px;
    margin: 12px auto 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sidebar .logout-link .logo-footer a {
    width: 140px;
    height: 36px;
    padding: 0 !important;
    margin: 0 !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
  }
  .sidebar .logout-link .logo-footer a:hover,
  .sidebar .logout-link .logo-footer a:focus,
  .sidebar .logout-link .logo-footer a:active {
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    color: inherit !important;
  }
  .sidebar .logout-link .logo-footer img {
    width: 140px;
    height: 36px;
    object-fit: contain;
    display: block;
  }
  .sidebar .logout-link:hover .logo-footer a {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .sidebar-mini .sidebar .logout-link .logo-footer,
  .sidebar-mini .sidebar .logout-link .logo-footer a,
  .sidebar-mini .sidebar .logout-link .logo-footer img {
    width: 90px;
    height: 24px;
  }
  @media (min-width: 200px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
  .sidebar .support-ticket-item > a.buton-suport-custom {
    display: block;
    text-decoration: none;
  }
  .support-location-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .support-location-modal {
    width: 100%;
    max-width: 450px;
    margin: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
  .support-location-modal .modal-header {
    padding: 20px 20px 10px 20px;
    border-bottom: 1px solid #ebeef5;
    position: relative;
  }
  .support-location-modal .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
  .support-location-modal .close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
  }
  .support-location-modal .modal-body {
    padding: 20px;
  }
  .support-location-modal .modal-footer {
    padding: 15px 20px 20px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
  }
  .support-location-modal .modal-footer .button-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
  .support-location-modal .modal-footer .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .support-location-select-dropdown {
    z-index: 10000 !important;
  }
  .support-location-select.el-select .el-input:hover .el-input__icon,
  .support-location-select.el-select .el-input:hover input {
    color: inherit;
  }
  .support-location-select.el-select .el-input:hover input::placeholder {
    color: #c0c4cc;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue